/* Pocket Factory help assistant (Part 3, docs/part3/contracts.md) for the boxes of snippets/pocket-help.liquid: the fixed
   "Questions? Ask us" button with its panel, and the inline chat. One conversation per tab (sessionStorage pf_help_chat)
   serves every box. Worker text is only set as text; links come only from action fields, to the store's own hosts. */
(function (root) {
  const doc = root.document;
  // Each render links this file: the first run serves every box on the page, a second one stops here.
  if (!doc || root.PocketHelp) return;
  root.PocketHelp = {};
  const KEY = 'pf_help_chat', CHARS = 1200, MAIL = 'bryton@getpocketfactory.com', TYPES = ['product', 'card', 'quote', 'request', 'email'];
  const HOSTS = ['getpocketfactory.com', 'www.getpocketfactory.com', 'checkout.shopify.com'], SHOPS = ['getpocketfactory.myshopify.com', 'ccr866-tr.myshopify.com'];
  // Fixed along the bottom of the screen: the buy bar (with its 50% offer strip) and the guides' mobile action.
  const DOCKS = '[data-buy-bar],[data-pfa-mobile-cta]';
  const core = root.PocketCore, boxes = [];
  let mode = 'pending', busy = false, uid = 0, state;
  try { state = JSON.parse(root.sessionStorage.getItem(KEY)); } catch (_) {}
  state = { messages: (Array.isArray(state?.messages) ? state.messages : []).filter(m => /^(user|assistant)$/.test(m?.role) && typeof m.content === 'string').slice(-20),
    remaining: Number.isFinite(state?.remaining) ? state.remaining : null, locked: typeof state?.locked === 'string' ? state.locked : '' };
  state.messages.forEach(m => { m.id = ++uid; });
  const save = () => { try { root.sessionStorage.setItem(KEY, JSON.stringify(state)); } catch (_) {} };
  const add = m => { m.id = ++uid; state.messages = state.messages.concat(m).slice(-20); save(); };
  const capture = (name, props) => { try { root.PocketAnalytics?.capture?.(name, props); } catch (_) {} };
  const locked = () => !!state.locked || state.remaining === 0;
  const ready = value => mode === 'on' && !busy && !locked() && !!String(value).trim();
  const text = (v, max = 600) => (typeof v === 'string' || typeof v === 'number' ? String(v).trim().slice(0, max) : '');
  const money = v => { const n = Number(String(v).replace(/^\s*\$|,/g, '')); return text(v) && Number.isFinite(n) ? '$' + n.toLocaleString('en-US', n % 1 ? { minimumFractionDigits: 2, maximumFractionDigits: 2 } : {}) : text(v, 40); };
  // Built from text nodes only: nothing from the Worker is ever parsed as HTML.
  function el(tag, attrs, ...kids) {
    const node = doc.createElement(tag);
    for (const [k, v] of Object.entries(attrs)) if (v != null && v !== false) node.setAttribute(k, v === true ? '' : v);
    node.append(...kids.filter(Boolean));
    return node;
  }
  // An action link opens a path of this store, getpocketfactory.com, Shopify checkout or the shop's myshopify invoices.
  function link(value) {
    let url;
    try { url = new URL(value, root.location.href); } catch (_) { return null; }
    if (typeof value !== 'string' || value.length > 2048 || url.username || url.password) return null;
    if (/^\/(?![/\\])/.test(value) && url.origin === root.location.origin) return url.href;
    const shop = String(root.Shopify?.shop || ''), invoice = (SHOPS.includes(url.hostname) || (url.hostname === shop && shop.endsWith('.myshopify.com'))) && url.pathname.includes('/invoices/');
    return url.protocol === 'https:' && (HOSTS.includes(url.hostname) || invoice) ? url.href : null;
  }
  // A card preview comes from the Worker, the store or Shopify's CDN.
  const image = value => { try { const url = new URL(value); return !url.username && (url.origin === new URL(core.workerBase()).origin || url.origin === 'https://cdn.shopify.com') ? url.href : link(value); } catch (_) { return null; } };
  const mailto = (subject, body) => 'mailto:' + MAIL + (subject || body ? '?subject=' + encodeURIComponent(text(subject, 200)) + '&body=' + encodeURIComponent(text(body, 1500)) : '');
  const mail = () => el('a', { href: mailto() }, 'Email ' + MAIL);

  async function post(path, body) {
    const control = new root.AbortController(), timer = root.setTimeout(() => control.abort(), 30000);
    try {
      const response = await root.fetch(core.workerBase() + path, { method: 'POST', credentials: 'omit', signal: control.signal, body: JSON.stringify(body),
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-PF-Session': body.sessionId } });
      const data = await response.json().catch(() => null);
      return { status: response.status, data: data && typeof data === 'object' ? data : {} };
    } catch (error) {
      return { status: 0, data: { code: error?.name === 'AbortError' ? 'timeout' : 'network' } };
    } finally { root.clearTimeout(timer); }
  }
  const codeOf = (status, data) => (typeof data.code === 'string' ? data.code : status ? 'unknown' : 'network');

  async function send(value, box) {
    if (!ready(value)) return;
    add({ role: 'user', content: String(value).trim().slice(0, CHARS) });
    capture('pf_help_send', { placement: box.placement });
    busy = true;
    paint();
    // What the Worker reads: no error notes, one turn per role (an unanswered message joins the next), the last 12,
    // starting with the shopper, within its 24 KB.
    const turns = [];
    for (const m of state.messages) {
      const last = turns[turns.length - 1];
      if (m.error) continue;
      if (last?.role === m.role) last.content = (last.content + '\n\n' + m.content).slice(-CHARS);
      else turns.push({ role: m.role, content: m.content.slice(0, CHARS) });
    }
    const body = { sessionId: core.sessionId(), messages: turns.slice(-12), page: { url: root.location.href.slice(0, 1000), title: doc.title.slice(0, 200) } };
    while (body.messages.length > 1 && (body.messages[0].role !== 'user' || new root.Blob([JSON.stringify(body)]).size > 23000)) body.messages.shift();
    const { status, data } = await post('/v1/help/chat', body);
    busy = false;
    if (status === 200 && typeof data.reply === 'string') {
      const action = TYPES.includes(data.action?.type) ? data.action : null;
      add({ role: 'assistant', content: data.reply.slice(0, 4000), action });
      if (Number.isFinite(data.remaining)) state.remaining = Math.max(0, data.remaining);
      if (action) capture('pf_help_action', { type: action.type });
    } else {
      const code = codeOf(status, data);
      capture('pf_help_error', { code });
      if (status === 404) mode = 'off'; // switched off: every box goes back to the email line
      else add({ role: 'assistant', error: code, content: text(data.error) || (status ? 'Something went wrong on our side. Please try again in a moment.' : 'We couldn’t reach the assistant. Check your connection and try again.') });
      if (/^(session_limit|ip_daily_limit)$/.test(code)) state.locked = code;
    }
    save();
    paint();
  }

  function bubble(m, box) {
    const user = m.role === 'user';
    return el('div', { class: 'pf-help__msg pf-help__msg--' + (user ? 'user' : 'bot') + (m.error ? ' pf-help__msg--error' : '') },
      el('span', { class: 'pf-help__sr' }, user ? 'You: ' : 'Pocket Factory: '), el('p', { class: 'pf-help__text' }, m.content),
      m.error && el('p', {}, mail()), m.action && card(m, box));
  }
  function card(m, box) {
    const { type, [type]: item } = m.action;
    const wrap = (...kids) => el('div', { class: 'pf-help__card' }, ...kids);
    const title = v => text(v) && el('p', { class: 'pf-help__card-title' }, text(v));
    const meta = v => v && el('p', { class: 'pf-help__meta' }, v);
    const go = (href, label) => href && el('a', { class: 'pf-help__button', href }, label);
    const pack = p => { const n = parseInt(p.pack, 10); return [n > 0 && n + (n === 1 ? ' card' : ' cards'), text(p.finish, 40), money(p.price)].filter(Boolean).join(' · '); };
    if (type === 'email') return wrap(go(mailto(m.action.subject, m.action.body), 'Email Bryton'));
    if (!item || typeof item !== 'object') return null;
    if (type === 'product') return wrap(title(item.title), meta(pack(item)), go(link(item.url), 'Open this card'));
    if (type === 'request') return wrap(el('p', {}, text(item.message)));
    if (type === 'card') {
      const src = image(item.previewUrl), img = src && el('img', { class: 'pf-help__preview', src, alt: 'The front of your card', width: 1086, height: 713, loading: 'lazy' });
      img?.addEventListener('error', () => { img.hidden = true; });
      return wrap(img, title('Your card'), meta(pack(item)), go(link(item.url), 'Check my card and pay'));
    }
    const row = (label, value, cls) => el('div', { class: cls }, el('dt', {}, text(label, 120)), el('dd', {}, money(value)));
    const lines = (Array.isArray(item.lines) ? item.lines : []).slice(0, 12).filter(line => line && typeof line === 'object');
    // Under the total: when it ships, and that shipping is free ("Ships in 3–5 business days · Free U.S. shipping"). A
    // narrow card wraps it after the dot, never inside "Free U.S. shipping".
    const node = wrap(title(item.summary), el('dl', { class: 'pf-help__lines' }, ...lines.map(line => row(line.label, line.amount)), row('Total', item.total, 'pf-help__total')), meta([text(item.turnaround), text(item.shipping).replace(/ /g, ' ')].filter(Boolean).join(' · ')));
    const done = link(m.checkoutUrl), ask = el('button', { type: 'button', class: 'pf-help__button' }, 'Get my checkout link');
    ask.addEventListener('click', () => checkout(m, box, ask));
    if (done) node.append(meta('Your checkout link is ready.' + (m.emailed ? ' We also emailed it to you.' : '')), go(done, 'Open my checkout'));
    else if (m.checkoutError) node.append(meta(m.checkoutError), el('p', {}, mail()));
    else node.append(item.checkout === true ? ask : meta('We’ll confirm the final price by email.'));
    return node;
  }
  // Asks for the email (prefilled with the last one typed in the chat), then POST /v1/help/checkout.
  function checkout(m, box, ask) {
    const id = 'PFHelpEmail' + ++uid, typed = state.messages.map(n => n.role === 'user' && n.content.match(/[^\s@<>(),;:"']+@[^\s@<>(),;:"']+\.[a-z]{2,}/i)).filter(Boolean).pop();
    const input = el('input', { class: 'pf-help__field', id, type: 'email', name: 'email', autocomplete: 'email', required: true, 'aria-describedby': id + 'Error' });
    const error = el('p', { class: 'pf-help__error', id: id + 'Error', hidden: true }), submit = el('button', { type: 'submit', class: 'pf-help__button' }, 'Send my checkout link');
    const form = el('form', { class: 'pf-help__checkout', novalidate: true }, el('label', { for: id }, 'Email for your checkout link'), input, submit, error);
    const fail = message => { error.textContent = message; error.hidden = false; input.setAttribute('aria-invalid', 'true'); input.focus(); };
    input.value = typed ? typed[0] : '';
    ask.replaceWith(form);
    input.focus({ preventScroll: true });
    form.scrollIntoView?.({ block: 'nearest' });
    form.addEventListener('submit', async event => {
      event.preventDefault();
      const email = input.value.trim();
      if (submit.disabled) return;
      if (email.length > 254 || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return fail('Enter an email address, like you@yourbusiness.com.');
      submit.disabled = true;
      const { status, data } = await post('/v1/help/checkout', { sessionId: core.sessionId(), quoteId: m.action.quote.id, email });
      submit.disabled = false;
      const url = status >= 200 && status < 300 && link(data.checkoutUrl), code = !url && codeOf(status, data);
      capture(url ? 'pf_help_checkout' : 'pf_help_error', url ? {} : { code });
      if (code === 'email_invalid' || !status) return fail(text(data.error) || 'We couldn’t reach the store. Check your connection and try again.');
      if (url) Object.assign(m, { checkoutUrl: url, emailed: data.emailed === true });
      else m.checkoutError = text(data.error) || 'We couldn’t make the checkout link just now. Try again in a minute.';
      save();
      // Every box showing this quote gets the result in its card; focus stays in the one that asked.
      for (const each of boxes) {
        const old = each.nodes.get(m.id)?.querySelector('.pf-help__card'), fresh = old && card(m, each);
        if (!fresh) continue;
        old.replaceWith(fresh);
        if (each === box) fresh.querySelector('a')?.focus();
      }
    });
  }

  const first = box => [box.input, box.left.querySelector('a'), box.fallback.querySelector('a'), box.close].find(node => node && !node.closest('[hidden]'));
  function paint() {
    const stop = locked(), left = state.remaining, ids = new Set(state.messages.map(m => m.id));
    for (const box of boxes) {
      box.chat.hidden = mode !== 'on';
      box.fallback.hidden = mode === 'on';
      for (const [id, node] of box.nodes) if (!ids.has(id)) { node.remove(); box.nodes.delete(id); }
      for (const m of state.messages) if (!box.nodes.has(m.id)) box.nodes.set(m.id, box.log.insertBefore(bubble(m, box), box.thinking.parentNode && box.thinking));
      if (busy) box.log.append(box.thinking); else box.thinking.remove();
      box.log.setAttribute('aria-busy', busy);
      box.form.querySelector('[type=submit]').disabled = busy;
      box.chips.hidden = stop || state.messages.length > 0;
      box.form.hidden = stop;
      const note = stop ? ['No more messages in this chat. For anything else, email ', el('a', { href: mailto() }, MAIL), '.'] : left > 0 && left <= 5 ? [left + (left === 1 ? ' message' : ' messages') + ' left in this chat.'] : [];
      box.left.replaceChildren(...note);
      box.left.hidden = !note.length;
      box.log.scrollTop = box.log.scrollHeight;
      // Focus never stays on a part that was just hidden (the chat switching on or off, or the box to type in closing).
      if (box.root.contains(doc.activeElement) && doc.activeElement.closest('[hidden]') && !box.panel?.hidden) first(box)?.focus();
    }
  }

  function setupLauncher(box) {
    const { launcher: button, panel } = box;
    // While the panel is open, the inline chat (the same conversation) stays quiet for screen readers.
    const quiet = on => boxes.forEach(each => { if (!each.panel) each.log.setAttribute('aria-live', on ? 'off' : 'polite'); });
    // On phones (and short landscape screens) the panel is a sheet over most of the page (CSS), so there it is modal:
    // Tab stays in it and Escape closes it. A tap on the page above it closes it too; focus moved out any other way (a
    // script on the page) comes back.
    const sheet = root.matchMedia?.('(max-width:599px),(max-height:520px)');
    const modal = () => { if (!panel.hidden && sheet?.matches) panel.setAttribute('aria-modal', 'true'); else panel.removeAttribute('aria-modal'); };
    const shut = () => { panel.hidden = true; button.setAttribute('aria-expanded', 'false'); modal(); quiet(false); opener = null; };
    // Focus first: the button may be stepping aside (below), and it stays shown while it has focus. Opened from
    // elsewhere (the buy bar's "Questions?"), the panel shuts first and focus goes back there: while the sheet is
    // still modal, focus moving out of it is pulled back in.
    const close = () => {
      const back = opener?.isConnected ? opener : null;
      if (back) { shut(); back.focus(); return; }
      button.focus(); shut();
    };
    // On touch screens the panel's title takes focus, so the keyboard doesn't cover the greeting and suggestions.
    const focusIn = () => (root.matchMedia?.('(pointer: coarse)').matches ? box.root.querySelector('.pf-help__title') : first(box))?.focus();
    let tapped = -Infinity, opener = null;
    button.hidden = false;
    const open = from => {
      if (!panel.hidden) return;
      opener = from || null;
      panel.hidden = false;
      button.setAttribute('aria-expanded', 'true');
      modal();
      quiet(true);
      capture('pf_help_open', { placement: from ? 'bar' : 'launcher' });
      paint();
      focusIn();
    };
    button.addEventListener('click', () => { if (!panel.hidden) return close(); open(null); });
    // The buy bar's "Questions?" (assets/pocket-cro.js) opens this same chat; focus comes back to it on close.
    root.PocketHelp.open = from => open(from instanceof root.HTMLElement ? from : null);
    box.close.addEventListener('click', close);
    sheet?.addEventListener?.('change', modal);
    box.root.addEventListener('keydown', event => {
      if (event.key === 'Escape' && !panel.hidden) { event.preventDefault(); close(); return; }
      if (event.key !== 'Tab' || !panel.hasAttribute('aria-modal')) return;
      const items = [...panel.querySelectorAll('a[href],button,input,textarea,select,[tabindex]')].filter(node => node.tabIndex >= 0 && !node.disabled && !node.closest('[hidden]'));
      const at = doc.activeElement, last = items[items.length - 1];
      if (event.shiftKey ? at === items[0] || !items.includes(at) : at === last || !panel.contains(at)) { event.preventDefault(); (event.shiftKey ? last : items[0])?.focus(); }
    });
    // Escape with nothing focused (after a tap on the page's text) closes it too.
    doc.addEventListener('keydown', event => {
      tapped = -Infinity;
      if (event.key === 'Escape' && panel.hasAttribute('aria-modal') && (event.target === doc.body || event.target === doc.documentElement)) { event.preventDefault(); close(); }
    });
    doc.addEventListener('pointerdown', event => { if (!box.root.contains(event.target)) tapped = event.timeStamp; }, true);
    doc.addEventListener('focusin', event => {
      if (!panel.hasAttribute('aria-modal') || box.root.contains(event.target)) return;
      if (event.timeStamp - tapped < 1000) shut();
      else if (panel.contains(event.relatedTarget)) event.relatedTarget.focus(); else focusIn();
    });
    // It steps aside instead of covering an inline chat on screen, and on phones (CSS) the homepage's website entry or
    // what is marked data-pf-help-avoid: the docs hero's "Design my card", the homepage's two card questions, the card
    // purpose choices, the product page's "Change business", and on /cart each line's −, + and
    // Remove and the Checkout and wallet buttons. It stays aside while any of them is on screen; ones added later are
    // watched too (a /cart line's controls are new nodes after each change, pocket.js refreshCartPage).
    const AVOID = '[data-rv-hero-entry],[data-pf-help-avoid]', shown = new Set(), spy = root.IntersectionObserver && new root.IntersectionObserver(entries => {
      entries.forEach(entry => shown[entry.isIntersecting ? 'add' : 'delete'](entry.target));
      shown.forEach(node => { if (!node.isConnected) shown.delete(node); });
      box.root.classList.toggle('pf-help--away', [...shown].some(node => node.matches('.pf-help')));
      box.root.classList.toggle('pf-help--hero', [...shown].some(node => !node.matches('.pf-help')));
    });
    if (spy) {
      [...boxes.filter(each => !each.panel).map(each => each.root), ...doc.querySelectorAll(AVOID)].forEach(node => spy.observe(node));
      new root.MutationObserver(records => records.forEach(record => record.addedNodes.forEach(node => {
        if (node.nodeType !== 1) return;
        if (node.matches(AVOID)) spy.observe(node);
        node.querySelectorAll(AVOID).forEach(each => spy.observe(each));
      }))).observe(doc.body, { childList: true, subtree: true });
    }
    // The button sits above what is fixed along the bottom, measured where it rests (offsetTop leaves out a slide-in
    // transform, so a bar coming in is never covered), and above the offer strip when it sticks out under the button.
    // Where it rests is also read from its own bottom offset, and the higher of the two is used: a phone browser can
    // place a fixed bar against a viewport other than the one offsetTop is measured in while its toolbar moves.
    let queued = false;
    const update = () => {
      const spot = button.getBoundingClientRect();
      let top = root.innerHeight;
      const docked = [];
      queued = false;
      for (const node of doc.querySelectorAll(DOCKS)) {
        const style = root.getComputedStyle(node), rect = node.getBoundingClientRect(), tab = node.querySelector('[data-pfx-offer]:not([hidden])')?.getBoundingClientRect();
        if (style.position !== 'fixed' || style.display === 'none' || style.visibility === 'hidden' || !rect.height || node.offsetTop + node.offsetHeight <= root.innerHeight / 2) continue;
        docked.push(node);
        // Its drawn top counts only when higher still (a bar sliding in is lower, never higher, than where it rests).
        const bottom = parseFloat(style.bottom), rest = Math.min(node.offsetTop, rect.top, Number.isFinite(bottom) ? root.innerHeight - bottom - node.offsetHeight : Infinity);
        top = Math.min(top, rest + Math.min(0, tab?.height && tab.right > spot.left && tab.left < spot.right ? tab.top - rect.top : 0));
      }
      const lift = Math.max(0, Math.ceil(root.innerHeight - top)) + 'px', asks = docked.some(node => node.querySelector('[data-pfx-questions]'));
      // A docked bar with its own "Questions?" (Bryton, Oct 22): the button steps aside (CSS), so it never covers the
      // bar, the plan tiles or a field being filled in.
      box.root.classList.toggle('pf-help--questions', asks);
      if (box.root.style.getPropertyValue('--pf-help-lift') !== lift) box.root.style.setProperty('--pf-help-lift', lift);
      // Over a docked bar, phones show just its icon (CSS), so it covers less of the page.
      box.root.classList.toggle('pf-help--docked', top < root.innerHeight);
    };
    const schedule = () => { if (!queued) { queued = true; (root.requestAnimationFrame || root.setTimeout)(update); } };
    const watch = new root.MutationObserver(schedule);
    watch.observe(doc.documentElement, { attributes: true, attributeFilter: ['class', 'style'] });
    doc.querySelectorAll(DOCKS).forEach(node => { watch.observe(node, { attributes: true, subtree: true, attributeFilter: ['class', 'style', 'hidden', 'data-state'] }); if (root.ResizeObserver) new root.ResizeObserver(schedule).observe(node); });
    doc.addEventListener('transitionend', schedule, true);
    root.addEventListener('resize', schedule, { passive: true });
    update();
  }

  function init(node) {
    const box = { root: node, placement: node.dataset.pfHelp === 'inline' ? 'inline' : 'launcher', nodes: new Map(), thinking: el('p', { class: 'pf-help__msg pf-help__msg--bot pf-help__thinking' }, 'Thinking…') };
    for (const part of ['chat', 'fallback', 'log', 'chips', 'form', 'input', 'left', 'launcher', 'panel', 'close']) box[part] = node.querySelector(`[data-pf-help-${part}]`);
    if (node.dataset.pfHelpReady || ['chat', 'fallback', 'log', 'chips', 'form', 'input', 'left'].some(part => !box[part])) return;
    node.dataset.pfHelpReady = 'true';
    const submit = () => { const value = box.input.value; if (ready(value)) { box.input.value = ''; send(value, box); } };
    box.form.addEventListener('submit', event => { event.preventDefault(); submit(); });
    box.input.addEventListener('keydown', event => { if (event.key === 'Enter' && !event.shiftKey && !event.isComposing) { event.preventDefault(); submit(); } });
    box.chips.addEventListener('click', event => { const chip = event.target.closest('[data-pf-help-chip]'); if (chip) send(chip.textContent, box); });
    boxes.push(box);
    if (box.launcher && box.panel && box.close) setupLauncher(box);
    else node.addEventListener('focusin', () => { if (!box.opened) capture('pf_help_open', { placement: 'inline' }); box.opened = true; });
    paint();
  }

  const start = scope => scope.querySelectorAll?.('[data-pf-help]').forEach(init);
  start(doc);
  doc.addEventListener('shopify:section:load', event => start(event.target));
  // The chat shows only when the Worker's switch is on; otherwise (or unreachable) the boxes keep the email line.
  Promise.resolve(core?.capabilities?.()).then(found => found?.helpChat === true, () => false).then(on => {
    if (mode === 'pending') mode = on ? 'on' : 'off';
    paint();
  });
})(typeof window !== 'undefined' ? window : globalThis);
